import { jwtDecode } from "jwt-decode";

export const isTokenExpired = (token: string): boolean => {
  if (!token) return true; // No token means user is not logged in

  try {
    const decoded: any = jwtDecode(token);
    return decoded.exp * 1000 < Date.now(); // Check expiration
  } catch (error) {
    return true; // If decoding fails, assume expired
  }
};
